(function($) {
    'use strict';
    $('.fullwidth').closest('.container').css({ width: '100%', padding: '0' });
    var bLoop = false;
    if ($('.swiper-container .swiper-slide').length > 1) {
        bLoop = true;
    } else {
        $('.carousel-pager, .carousel-go-left, .carousel-go-right').hide();
    }

    var reverseDirection = $('html').attr('lang') === 'ar-MI';

    var carouselConfig = {
        spaceBetween: 0,
        slidesPerView: 1,
        loop: bLoop,
        autoplay: {
            delay: 3000,
            reverseDirection: reverseDirection
        },
        speed: 1000,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    };

    if ($('.product-intro-carousel .swiper-container').length > 0) {
        carouselConfig.autoplay = false;
    }

    new window.Swiper('.swiper-container', carouselConfig);

    if ($('.swiper-container .swiper-slide').length > 3) {
        $('.carousel-pager, .carousel-go-left, .carousel-go-right').show();
    }
})(jQuery);
